// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/RetractablePanel/RetractablePanel.less
// module id = 831
// module chunks = 0